import { useContext } from "react";
import { CartCountContext } from "../providers/cartCountProvider";

export default function useCartCount() {
  const context = useContext(CartCountContext);
  if (context === undefined) {
    throw new Error("useCartCount must be used within a CartCountProvider");
  }
  return context;
}
